module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/workshops-a9ed84a036e8a42dcc76b12bc82615e8.svg";